// extracted by mini-css-extract-plugin
export default {"input":"M--z","button":"N--z","selected":"O--z","unavailable":"P--z","oos":"Q--z","image":"R--z","paperCutDisabledOverlay":"S--z"};